<template>
     <div>
        <van-nav-bar   title="测土配方"  left-text="返回" @click-left="back"    left-arrow/>
        <div class='main'>
            <div id="gdMap_soil"></div>           
            <van-panel icon='comment-o' color="#f00" title="测土点信息" >
                <div style="font-size:14px;padding:15px">{{text}}</div>
            </van-panel>
            <van-button class='vbtn' size='small' type="info" block>申请免费测土</van-button>
        </div>
        
        
    </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
    name:'soilFormula',
    data() {
        return {
            text:'该测土点暂无信息'
        }
    },
    mounted() {
        this.createMap()
    },
    computed: {
        ...mapState(['phonePosition'])
    },
    methods: {
        createMap(){
             let map = new AMap.Map('gdMap_soil', {
                resizeEnable: true,
                center: [this.phonePosition.lon,this.phonePosition.lat],
                zoom: 15
            });

            let marker = new AMap.Marker({
                position: map.getCenter(),
                // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                // offset: new AMap.Pixel(-13, -30)
            });
            marker.setMap(map);
        },
        back(){
            this.$router.back(-1)
        }
    },

}
</script>

<style  scoped>
.main{ position:relative; width:100%; top:46px; bottom:0;overflow:auto;}
#gdMap_soil{width:100%;height:250px}
.vbtn{width:95%;margin: 15px auto}
</style>